import React, { useState } from 'react'
import { CardBody, Icons, Table } from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { get as _get } from 'lodash'
import { FbTableColumn, FbTablePagination, FbTableRow } from '@fabricks/ui-components/dist/components/Table/Table'
import { Skeleton } from '@material-ui/lab'
import { BoxTypeDto } from '../../api/models'
import { useBoxtypes } from "../../services/dataService";
import { Navigation, getDynamicRouteGetters as dynamicRoutes } from "../../constants/navigation";
import { useHistory } from "react-router-dom";

interface BoxtypesTableProps {
}

export const BoxtypesTable: React.FC = (props: BoxtypesTableProps) => {
    const [initLoading, setInitLoading] = useState(true)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [keycloak] = useKeycloak()
    const { data, error, loading } = useBoxtypes(keycloak.token, {
        pagination: { page, size: pageSize },
        sort: [],
        filter: [],
        q: null
    })
    const history = useHistory()

    const columns: FbTableColumn[] = [
        { id: 'name', label: 'Name' },
        { id: 'innerWidth', label: 'Inner width', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        { id: 'innerHeight', label: 'Inner height', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        { id: 'innerDepth', label: 'Inner depth', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        {
            id: 'isActive', label: 'Active', renderValue: (isActive: boolean) => {
                if (isActive) {
                    return (<div className="indicator_check" style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer' }}>
                        <Icons.Check /></div>)
                }
                return (<div className="indicator_error" style={{ color: '#d32f2f', cursor: 'pointer' }}>
                    <Icons.NotInterested /></div>)
            }
        },
        {
            id: 'isValid', label: 'Integrity', renderValue: (isValid: boolean) => {
                if (isValid) {
                    return (<div className="indicator_check" style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer' }}>
                        <Icons.Check /></div>)
                }
                return (<div className="indicator_error" style={{ color: '#d32f2f', cursor: 'pointer' }}>
                    <Icons.NotInterested /></div>)
            }
        }
    ]
    const pagination: FbTablePagination = {
        rowsPerPage: _get(data, 'getBoxTypes.meta.size', pageSize),
        currentPage: _get(data, 'getBoxTypes.meta.offset', page),
        count: _get(data, 'getBoxTypes.meta.count', 0),
        onChangeRowsPerPage: event => setPageSize(parseInt(event.target.value, 10)),
        onChangePage: (event, newPage) => setPage(newPage),
    }
    const rows: FbTableRow[] = _get(data, 'getBoxTypes.data', []).map((boxType: BoxTypeDto) => {
        return {
            uuid: boxType.uuid,
            name: boxType.name,
            innerWidth: _get(boxType, 'inner.width', ''),
            innerHeight: _get(boxType, 'inner.height', ''),
            innerDepth: _get(boxType, 'inner.depth', ''),
            isValid: boxType.isValid,
            isActive: boxType.isActive,
        }
    })

    if (loading) {
        return (
            <>
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
            </>
        )
    }

    if (_get(data, 'getBoxTypes.error', null) != null) {
        return (
            <div>
                {_get(data, 'getBoxTypes.error.message', '')}
                {_get(data, 'getBoxTypes.error.code', '')}
            </div>
        )
    }

    if (error) {
        return <div>An unknown error has occured</div>
    }
    return (
        <Table
            columns={columns}
            pagination={pagination}
            rows={rows}
            onRowClick={(uuid: string) => history.push(dynamicRoutes().pages.editBoxtypes(uuid))}
        />
    );
}

export default BoxtypesTable
